module.exports = __webpack_public_path__ + "img/emba_g_online.d19cc21a.png";